import { atomWithKey as atom } from "./atomWithKey";
import { IFAQResponse } from "../../Orchestrator/Types/Interface/ICmsGroupBooking";

export const cmsGroupBookingAtom = atom<IFAQResponse | null>({
  key: "cmsGroupBookingAtom",
  default: null,
});
